import { useContext } from 'react';
import tagIds from '~/constants/common/tagIds';
import TransitChargeState from '~/constants/vdp/TransitChargeState';
import DiscountContext from '~/context/common/DiscountContext';
import { useTransitChargeInfo } from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

const maxPriceThreshold = 25000;
const checkPriceThreshold = maxPriceThreshold - 2500;

export default function useGetShowEVTaxTreatment() {
  const showEVTaxTreatment = Boolean(useGetVehicleDetails().evTaxCreditAmount);
  const { highlights, price = 0 } = useGetVehicleDetails();
  const {
    totalDiscount,
    discounts: { isLoaded: isDiscountsLoaded }
  } = useContext(DiscountContext);

  const {
    charge: transitCharge,
    isLoaded: isTransitChargeLoaded,
    state
  } = useTransitChargeInfo();

  const meetsThreshold =
    price + transitCharge - totalDiscount <= maxPriceThreshold;
  const hasEvTag =
    highlights?.some(
      highlight => highlight.tagId === tagIds.EvTaxCreditMayBeEligible
    ) ?? false;

  if (!hasEvTag) {
    return showEVTaxTreatment;
  }

  if (price <= checkPriceThreshold) {
    return true;
  }

  return state === TransitChargeState.Unknown
    ? false
    : meetsThreshold && isTransitChargeLoaded && isDiscountsLoaded;
}
